import {
  GET_DELIVERY_AREAS_REQUEST,
  PULL_DELIVERY_AREAS_REQUEST,
  UPDATE_DELIVERY_AREA_GOVERNORATE_REQUEST,
} from '../types/deliveryAreas'

export function getDeliveryAreas(payload) {
  return {
    type: GET_DELIVERY_AREAS_REQUEST,
    payload,
  }
}

export function pullDeliveryAreas(payload) {
  return {
    type: PULL_DELIVERY_AREAS_REQUEST,
    payload,
  }
}

export function updateDeliveryAreaGovernorate(payload) {
  return {
    type: UPDATE_DELIVERY_AREA_GOVERNORATE_REQUEST,
    payload,
  }
}

